import { IconButton } from '@mui/material';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import GameCompleteCard from './gameCompleteCard';
import GameInProgressCard from './gameInProgressCard';
import GameNotStartedCard from './gameNotStartedCard';
import gameFormatService from '../../../features/gameFormat/gameFormatService';
import GameCardBase from './gameStatusCardBase';
import ScoringDisplay from '../playerDisplay/scoringDisplay';

const GameByStatusCardPublicBasic = ({
  game,
  actions = true,
  showSectionWinners,
  bsaNumber,
  onDelete,
  portal
}) => {
  const headerAction = onDelete ? (
    <IconButton size="small" color="error" aria-label="Delete game" onClick={onDelete}>
      <DeleteOutline fontSize="small" />
    </IconButton>
  ) : null;

  const manual =
    game.scoringMethod === 'inputfinalscore' || game.scoringMethod === 'inputtotals';

  // The portal game page keeps the card shell but swaps in the full scoring
  // display that the public per-game page uses, so officials get the same
  // score buttons, undo, set controls and scorecard photo tool. A manual game
  // is entered as a final score, but once it is complete it uses the same
  // display so the undo and photo controls sit inside the card like the QR
  // scoring page instead of below it.
  const scoringDisplay =
    portal?.detail &&
    (manual
      ? game.status === gameFormatService.GameStatus.COMPLETE
      : game.status === gameFormatService.GameStatus.IN_PROGRESS ||
        game.status === gameFormatService.GameStatus.PLAYOFF ||
        game.status === gameFormatService.GameStatus.COMPLETE);

  if (scoringDisplay) {
    return (
      <GameCardBase game={game} actions={actions} headerAction={headerAction} portal={portal}>
        <ScoringDisplay game={game} portal={portal} />
      </GameCardBase>
    );
  }

  switch (game.status) {
    case gameFormatService.GameStatus.NOT_STARTED:
      // A manual-score game is started by entering its score, not by the
      // end-by-end start endpoint, so give the portal the same score dialog
      // it shows once the game is running.
      if (portal && manual) {
        return (
          <GameCardBase game={game} actions={actions} headerAction={headerAction} portal={portal}>
            <GameInProgressCard
              game={game}
              actions={actions}
              showSectionWinners={showSectionWinners}
              isPublic={true}
              bsaNumber={bsaNumber}
              portal={portal}
            />
          </GameCardBase>
        );
      }

      return (
        <GameCardBase game={game} actions={actions} headerAction={headerAction} portal={portal}>
          <GameNotStartedCard game={game} actions={actions} isPublic={true} portal={portal} />
        </GameCardBase>
      );
    case gameFormatService.GameStatus.IN_PROGRESS:
      return (
        <GameCardBase game={game} actions={actions} headerAction={headerAction} portal={portal}>
          <GameInProgressCard
            game={game}
            actions={actions}
            showSectionWinners={showSectionWinners}
            isPublic={true}
            bsaNumber={bsaNumber}
            portal={portal}
          />
        </GameCardBase>
      );
    case gameFormatService.GameStatus.PLAYOFF:
      return (
        <GameCardBase game={game} actions={actions} headerAction={headerAction} portal={portal}>
          <GameInProgressCard
            game={game}
            actions={actions}
            showSectionWinners={showSectionWinners}
            isPublic={true}
            bsaNumber={bsaNumber}
            portal={portal}
          />
        </GameCardBase>
      );
    case gameFormatService.GameStatus.COMPLETE:
      return (
        <GameCardBase game={game} actions={actions} headerAction={headerAction} portal={portal}>
          <GameCompleteCard
            game={game}
            actions={actions}
            isPublic={true}
            bsaNumber={bsaNumber}
            portal={portal}
          />
        </GameCardBase>
      );
    default:
      return null;
  }
};

export default GameByStatusCardPublicBasic;
